import { render, staticRenderFns } from "./userExamine.vue?vue&type=template&id=3d48d5ed&"
import script from "./userExamine.vue?vue&type=script&lang=js&"
export * from "./userExamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports